import type { WorkItem } from '../common/models';

export const ASSIGNED_GROUP_LABEL = 'Assigned to me';
export const PARTICIPATED_GROUP_LABEL = 'Also participated';

// Splits a pick list into directly-assigned and participated-only, order within
// each group preserved. Grouping is for choosing an item; once one is picked it
// leaves the list, so nothing regroups underneath the pointer.
export const partitionByAssignment = (items: readonly WorkItem[]): { assigned: WorkItem[]; participated: WorkItem[] } => {
    const assigned: WorkItem[] = [];
    const participated: WorkItem[] = [];
    for (const item of items) {
        if (item.assignedToMe) {
            assigned.push(item);
        } else {
            participated.push(item);
        }
    }
    return { assigned, participated };
};
